import { useState } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FORTA_BLUE, FORTA_GRAY4 } from '../../../../../../utils/colors';

interface InstructionsProps {
  instructions: string;
}

const TargetInstruction = (props: InstructionsProps) => {
  const { instructions } = props;
  const { t } = useTranslation('sessionNotes');
  const [isInstructionExpanded, setIsInstructionExpanded] = useState(false);

  const toggleIsInstructionExpanded = () => {
    setIsInstructionExpanded(!isInstructionExpanded);
  };
  const maxLength = 200;

  const shownText =
    instructions.length > maxLength && !isInstructionExpanded
      ? instructions.substring(0, maxLength) + '...'
      : instructions;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <Typography
        sx={{
          my: 1,
          mx: { xs: 0, sm: 2 },
          pl: 1,
          borderLeft: `1px solid ${FORTA_BLUE.light2}`,
          color: FORTA_GRAY4,
        }}
      >
        <span style={{ fontWeight: 'bold' }}>{t('goalsPracticed.instructions')}: </span>
        {shownText}
      </Typography>
      {instructions.length > maxLength && (
        <Link
          onClick={toggleIsInstructionExpanded}
          sx={{
            fontSize: 14,
            cursor: 'pointer',
            color: FORTA_BLUE.bright,
            '&:hover': {
              color: FORTA_BLUE.primary,
            },
            paddingLeft: '16px',
            marginBottom: '16px',
          }}
        >
          {isInstructionExpanded ? 'see less' : 'see more'}
        </Link>
      )}
    </Box>
  );
};

export default TargetInstruction;
